import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import logs from './logs'
import search from './search'
import resetPassword from './resetPassword'
import showDisplay from './showDisplay'
import instructions from './instructions'
import tasks from './tasks'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    logs,
    search,
    instructions,
    resetPassword,
    showDisplay,
    tasks
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js